<div class="container-fluid bg-light" style="  background-size: cover;">
    <div class="row bg-danger" style="z-index: -1; height: 100px;">
  </div>
</div>
    
        <div class="row"  style="margin-top: -80px; z-index: -1; ">
            <div class="col-10  mx-auto shadow-sm" style="height: 92vh;">
                <div style="background-color:white">
                    <app-online-user></app-online-user>
                </div>
                <div class="row" style="height:80vh" style="background-color:white">
                    <div class="col-md-4 col-6  shadow-sm" >
                        <app-contact></app-contact>   
                    </div>
                <div class="col-md-8 col-8  shadow-sm" id="message">
                       <app-message></app-message>  
                </div>  
                </div> 
            </div>
                  
                
                
           
       </div>
      
      